import { createContext } from "react";

export const AgentContext = createContext();
export const TicketContext = createContext();
